var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notes"},[_c('the-sidebar',{staticClass:"notes-sidebar"}),_c('div',{staticClass:"notes-main"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }